(function() {
    'use strict';

    let desktopLayoutThresh = 900;          // desktop (alternate layout) kicks in at 900px

    const arrowSVG = '<svg width="64" height="64"><use xlink:href="/wp-content/themes/wpt_hlm/svg/icons/fa-icons-min.svg#chevron-up" /></svg><span class="h2">Top</span>';

    // Create a button element
    const button = document.createElement('button');
    button.classList.add('btnToTop', 'hidden');

    // Set the button SVG
    button.innerHTML = arrowSVG;

    button.addEventListener('click', (e) => {
        const scrollTime = window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches ? 800 : 500;
        scrollToPos(0, scrollTime);
    });


    function scrollToTopHandler() {
        const scrollOffset = window.scrollY;
        
        if (scrollOffset >= 400) {
            button.classList.remove('hidden');

        } else if (scrollOffset <= 0) {
            button.classList.add('hidden');
        }   
    }
    
    window.addEventListener('scroll', scrollToTopHandler);
    document.body.appendChild(button);
    scrollToTopHandler();
})();